import { useQuery } from '@tanstack/react-query';
import * as authApi from '../api/auth';
import { useAuthStore } from '../stores/authStore';

// Packet A2: onboarding_complete is derived server-side in GET /users/me
// (EXISTS active learner), not persisted in Zustand. A 30s staleTime keeps
// the value fresh enough for guard decisions without hammering the API.
export function useMe() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: ['me'],
    queryFn: () => authApi.getMe(),
    enabled: isAuthenticated,
    staleTime: 30_000,
  });
}
